/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DeliveryDto } from '../models/DeliveryDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DeliveryControllerService {
    /**
     * @param uuid
     * @returns DeliveryDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<DeliveryDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/deliveries/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns DeliveryDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: DeliveryDto,
    ): CancelablePromise<DeliveryDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/deliveries/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/deliveries/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns DeliveryDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<DeliveryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/deliveries',
        });
    }
    /**
     * @param requestBody
     * @returns DeliveryDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: DeliveryDto,
    ): CancelablePromise<DeliveryDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/deliveries',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param supplier
     * @returns DeliveryDto OK
     * @throws ApiError
     */
    public static getDeliveriesBySupplier(
        supplier: string,
    ): CancelablePromise<Array<DeliveryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/deliveries/supplier/{supplier}',
            path: {
                'supplier': supplier,
            },
        });
    }
    /**
     * @param status
     * @returns DeliveryDto OK
     * @throws ApiError
     */
    public static getDeliveriesByStatus(
        status: 'PENDING' | 'IN_TRANSIT' | 'RECEIVED' | 'CANCELLED' | 'DELAYED',
    ): CancelablePromise<Array<DeliveryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/deliveries/status/{status}',
            path: {
                'status': status,
            },
        });
    }
    /**
     * @returns DeliveryDto OK
     * @throws ApiError
     */
    public static getReceivedDeliveries(): CancelablePromise<Array<DeliveryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/deliveries/received',
        });
    }
    /**
     * @returns DeliveryDto OK
     * @throws ApiError
     */
    public static getPendingDeliveries(): CancelablePromise<Array<DeliveryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/deliveries/pending',
        });
    }
    /**
     * @param materialUuid
     * @returns DeliveryDto OK
     * @throws ApiError
     */
    public static getDeliveriesByMaterial(
        materialUuid: string,
    ): CancelablePromise<Array<DeliveryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/deliveries/material/{materialUuid}',
            path: {
                'materialUuid': materialUuid,
            },
        });
    }
    /**
     * @returns DeliveryDto OK
     * @throws ApiError
     */
    public static getInTransitDeliveries(): CancelablePromise<Array<DeliveryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/deliveries/in-transit',
        });
    }
    /**
     * @param expectedDate
     * @returns DeliveryDto OK
     * @throws ApiError
     */
    public static getDeliveriesByExpectedDate(
        expectedDate: string,
    ): CancelablePromise<Array<DeliveryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/deliveries/expected-date/{expectedDate}',
            path: {
                'expectedDate': expectedDate,
            },
        });
    }
    /**
     * @param startDate
     * @param endDate
     * @returns DeliveryDto OK
     * @throws ApiError
     */
    public static getDeliveriesByExpectedDateRange(
        startDate: string,
        endDate: string,
    ): CancelablePromise<Array<DeliveryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/deliveries/expected-date-range',
            query: {
                'startDate': startDate,
                'endDate': endDate,
            },
        });
    }
    /**
     * @returns DeliveryDto OK
     * @throws ApiError
     */
    public static getDelayedDeliveries(): CancelablePromise<Array<DeliveryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/deliveries/delayed',
        });
    }
}
